<template>
  <!-- <list-view-page
    title='Rules'
    help-text='You can use rules to automate common behavior'
    :list-item='li'
    :attrs='attrs'
    :request.sync='request'
    object-path='result' /> -->
  <!-- {{request}} -->
<v-container>
  <v-row>
    <v-col cols=12 >
      <v-alert type='info' border='left' text full-width >
        The following rules have been applied to your account. Contact support for help with rules
      </v-alert>
    </v-col>
  </v-row>
  <v-row class='mb-5' >
    <!-- <v-btn @click='get' /> -->
    <!-- <pre v-text="request.result" /> -->
    <v-col
      v-for='rule in rules'
      :key='rule.id'
      cols=4 >
      <v-card dense
        height="100%" class='mt-3 pb-5' >
        <v-card-title class='overline' >
          {{rule.name}}
          <v-spacer/>
          <v-chip v-if='!rule.enabled' label x-small color='warning' >
            <v-icon left x-small>mdi-flash-off</v-icon>
            Disabled</v-chip>
        </v-card-title>
        <v-divider />
        <v-data-table dense hide-default-footer
          v-if='rule.task === "schedule.tasks.add_codes"'
          :headers="headers"
          :items="rule.extra_data.codes" >
        </v-data-table>
        <v-card-text v-if='rule.task === "schedule.tasks.add_invoice_details"' >
          <strong>Sets invoice description to:</strong> {{rule.extra_data.description}}
        </v-card-text>
        <!-- <pre v-text='rule' /> -->
        <!-- <v-card-text>
          {{rule.extra_data}}
        </v-card-text> -->

        <v-footer absolute botton class='caption' >
          <template v-if='rule.type === "tag"' >
            <v-chip x-small >
              <v-icon x-small left >mdi-tag</v-icon>
              {{rule.tag}}
            </v-chip>
          </template>
          <template v-else >
            Applied when a new appointment is created
          </template>
        </v-footer>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>
<script>
// import ListViewPage from '@/components/layouts/ListViewPage.vue'
export default {
  name: 'OperatingHours',
  // components: {ListViewPage},
  data () {
    return {
      request: {
        resource: 'ag.practitioner.rules'
      },
      attrs: {
        withEdit: true,
        titleField: 'name'
      }
    }
  },
  mounted () {
    this.get()
  },
  computed: {
    rules () {
      return this.getObjectPath(this.request, 'result', [])
    },
    headers () {
      return [
        { text: 'ICD-10', value: 'icd10' },
        { text: 'Tariff codes', value: 'process' },
        { text: 'price', value: 'price' },
      ]
    }
  },
  methods: {
    get () {
      this.$request('get', this.request)
    }
  }
}
</script>
